import { createLink } from "@tanstack/react-router";
import MuiLink from "@mui/material/Link";


const CustomLink = createLink(MuiLink);

export default function Link({ tab, ...props }) {
	return <CustomLink underline="none" target={tab ? "_blank" : undefined} rel={tab ? "noopener noreferrer" : undefined} {...props} />;
}